import $ from "jquery";

$(document).ready(function () {
	var dropdowns = new ET_Dropdowns();
});

function ET_Dropdowns() {
	this.init();
}

ET_Dropdowns.prototype.init = function () {
	console.log("Empezamos los dropdowns");
	$(".et-block-dropdown-item").each(function (e) {
		var me = this;
		$(this)
			.find(".et-block-dropdown-item__header")
			.on("click", function (e) {
				e.preventDefault();
				$(me).toggleClass("is-opened");
			});
	});
};
